var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var MediaController = /** @class */ (function () {
    function MediaController() {
    }
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/media/file" and http method "POST" to call the back-end.
    
        * @param {MediaInfo} mediaInfo
        * @returns {LinkDto}
    ******************************************************************************************************/
    MediaController.GetByContainerAndName = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/media/file", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.mediaInfo
        });
    };
    /*****************************************************************************************************
        * Is using route "api/media/uploadFile" and http method "POST" to call the back-end.
    
        * @param {string} container
        * @param {string} fileName
        * @param {string} mediaType
        * @param {File} bytes
        * @returns {ContentMediaUploadDto}
    ******************************************************************************************************/
    MediaController.UploadFile = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("container", JSON.stringify(data.container));
        fd.append("fileName", JSON.stringify(data.fileName));
        fd.append("mediaType", JSON.stringify(data.mediaType));
        if (data.bytes)
            fd.append("bytes", data.bytes);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/media/uploadFile", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/media/getUploadUrl" and http method "POST" to call the back-end.
    
        * @param {string} mediaType
        * @param {string} fileName
        * @returns {UploadMediaParametersDto}
    ******************************************************************************************************/
    MediaController.GetUploadUri = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.mediaType !== undefined)
            fd.append("mediaType", JSON.stringify(data.mediaType));
        if (data.fileName !== undefined)
            fd.append("fileName", JSON.stringify(data.fileName));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/media/getUploadUrl", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/media/getUploadUrlWithContainer" and http method "POST" to call the back-end.
    
        * @param {string} mediaType
        * @param {string} fileName
        * @param {string} container
        * @returns {UploadMediaParametersDto}
    ******************************************************************************************************/
    MediaController.GetUploadUriWithContainer = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.mediaType !== undefined)
            fd.append("mediaType", JSON.stringify(data.mediaType));
        if (data.fileName !== undefined)
            fd.append("fileName", JSON.stringify(data.fileName));
        if (data.container !== undefined)
            fd.append("container", JSON.stringify(data.container));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/media/getUploadUrlWithContainer", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/media/getUploadUrl/import" and http method "POST" to call the back-end.
    
        * @param {string} mediaType
        * @param {string} fileName
        * @returns {UploadMediaParametersDto}
    ******************************************************************************************************/
    MediaController.GetUploadUriForImport = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.mediaType !== undefined)
            fd.append("mediaType", JSON.stringify(data.mediaType));
        if (data.fileName !== undefined)
            fd.append("fileName", JSON.stringify(data.fileName));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/media/getUploadUrl/import", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/media/createAndGetUploadUrl" and http method "POST" to call the back-end.
    
        * @param {string} mediaType
        * @param {string} fileName
        * @returns {MediaDownloadDto}
    ******************************************************************************************************/
    MediaController.CreateAndGetUploadUri = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.mediaType !== undefined)
            fd.append("mediaType", JSON.stringify(data.mediaType));
        if (data.fileName !== undefined)
            fd.append("fileName", JSON.stringify(data.fileName));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/media/createAndGetUploadUrl", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/media/file/json" and http method "POST" to call the back-end.
    
        * @param {MediaInfo} mediaInfo
        * @returns {any}
    ******************************************************************************************************/
    MediaController.GetByContainerAndNameJson = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/media/file/json", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.mediaInfo
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/media/file/json/public" and http method "POST" to call the back-end.
    
        * @param {MediaInfo} mediaInfo
        * @returns {any}
    ******************************************************************************************************/
    MediaController.GetByContainerAndNameJsonPublic = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/media/file/json/public", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.mediaInfo
        });
    };
    /*****************************************************************************************************
        * Is using route "api/media/file/json" and http method "PUT" to call the back-end.
    
        * @param {string} container
        * @param {any} data
        * @returns {LinkDto}
    ******************************************************************************************************/
    MediaController.PutByContainerAndNameJson = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("container", JSON.stringify(data.container));
        fd.append("data", JSON.stringify(data.data));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/media/file/json", __assign({}, data)),
            method: "PUT",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/media" and http method "GET" to call the back-end.
    
        * @returns {MediaDownloadDto[]}
    ******************************************************************************************************/
    MediaController.Get = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/media", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/media/qrCode/{content}" and http method "GET" to call the back-end.
    
        * @param {string} content
        * @returns {void}
    ******************************************************************************************************/
    MediaController.GetQrCode = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/media/qrCode/{content}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    return MediaController;
}());
export { MediaController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=MediaController.js.map